import React from 'react'

const Loader = () => {
  return (
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      </div>
    </div>
  )
}

export default Loader
